export const INFO_RESOURCE_NAME = 'info';
